import React from 'react';
import { StyledIconButton } from './IconButton.styled';

const IconButton = ({ children, onClick, animated = true, disabled = false, backgroundOverwrite = null, backgroundOverwriteHover = null, borderOverwrite = null, borderOverwriteHover = null, rows = 1 }) => {
  return (
    <StyledIconButton onClick={() => disabled ? true : onClick()} $disabled={disabled} $animated={animated} $backgroundOverwrite={backgroundOverwrite} $backgroundOverwriteHover={backgroundOverwriteHover} $borderOverwrite={borderOverwrite} $borderOverwriteHover={borderOverwriteHover} $rows={rows}>
      <button className='icon-button'>
        {children}
      </button>
      <div className='icon-button-corner icon-button-corner-l' />
      <div className='icon-button-corner icon-button-corner-r' />
    </StyledIconButton>
  )
};

export default IconButton;

